module.exports = __webpack_public_path__ + "img/arrow-narrow-down.23409f25.svg";